const Locales = Object.freeze({
  GREEK: 'el',
  ENGLISH: 'en',
});
export default Locales;
